import TableRow from './container';

export default TableRow;
